import React from 'react';
import { useApp } from '@/context/AppContext';

export default function PurchaseSuccessScreen() {
  const { navigate } = useApp();

  return (
    <div
      data-testid="purchase-success-screen"
      className="min-h-screen bg-[#F5F6FA] flex flex-col items-center justify-center px-8"
    >
      {/* Green circle with gloss dot */}
      <div
        data-testid="success-icon"
        className="w-28 h-28 rounded-full bg-green-400 relative mb-10"
        style={{ boxShadow: '0 8px 32px rgba(74,222,128,0.35)' }}
      >
        <div className="w-4 h-4 rounded-full bg-white absolute top-4 left-5 opacity-60" />
      </div>

      <h1
        data-testid="success-title"
        className="font-black text-2xl text-gray-900 text-center leading-snug mb-3"
      >
        Purchase Request Sent<br />Successfully
      </h1>

      <p
        data-testid="success-subtitle"
        className="text-gray-400 text-sm text-center mb-14"
      >
        Intas team revert shortly
      </p>

      <button
        data-testid="success-home-btn"
        onClick={() => navigate('HOME')}
        className="px-12 py-4 rounded-2xl text-white font-black text-base tap-scale"
        style={{ background: 'linear-gradient(to right, #FF7043, #FF5722)' }}
      >
        Back to Home
      </button>
    </div>
  );
}
